module.exports = __webpack_public_path__ + "static/media/bnb-logo.9529b720.png";